import { render, staticRenderFns } from "./PrivacyPolicyLink.vue?vue&type=template&id=0cdb8201&"
import script from "./PrivacyPolicyLink.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports